import React, { FC } from 'react';
import { Flex, Text, Box } from 'roo-ui/components';
import { FooterLink } from '../primitives';
import { LinkOptions } from '../../../lib/types';

interface TermsConditionsProps {
  disclaimerLinks: LinkOptions[];
  abn: string;
}

export const TermsAndConditions: FC<TermsConditionsProps> = ({
  disclaimerLinks,
  abn,
}) => (
  <Flex flexWrap="wrap">
    {disclaimerLinks.map((link, index) => (
      <Box width={['50%', '25%']} key={`footer-link-${index}`}>
        <FooterLink mb={4} {...link} />
      </Box>
    ))}

    <Text color="white" data-testid="abn" fontSize="sm">
      {abn}
    </Text>
  </Flex>
);
